import { render } from "./myCadacMenu.vue?vue&type=template&id=695c8ce8&scoped=true&ts=true"
import script from "./myCadacMenu.vue?vue&type=script&lang=ts"
export * from "./myCadacMenu.vue?vue&type=script&lang=ts"

import "./myCadacMenu.vue?vue&type=style&index=0&id=695c8ce8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-695c8ce8"]])

export default __exports__